import { cloneDeep } from 'lodash';

export function isMobile() {
    const ua = /Mobi/i.test(window.navigator.userAgent);
    const match = window.matchMedia || (window as any).msMatchMedia;
    if (match) {
        let coarse = match('(pointer:coarse)');
        let fine = match('(any-pointer:fine)');
        return ua && coarse.matches && !fine.matches && window.innerWidth <= 1024;
    }
    return false;
}

export function sleep(ms: number): Promise<any> {
    return new Promise((res) => setTimeout(res, ms));
}

export function clone(v: any): any {
    return cloneDeep(v);
}

export function nullify(o: Record<string, any>) {
    for (const k in o) {
        if (o[k] === '') o[k] = null;
        if (typeof o[k] === 'object') nullify(o[k]);
    }
}

type CamelCase<S extends string> = S extends `${infer P1}_${infer P2}`
    ? `${Lowercase<P1>}${Capitalize<CamelCase<P2>>}`
    : S extends `${infer P1}-${infer P2}`
      ? `${Lowercase<P1>}${Capitalize<CamelCase<P2>>}`
      : S extends `${infer First}${infer Rest}`
        ? `${Lowercase<First>}${Rest}` // Converts PascalCase to camelCase
        : S;

export type ToCamelCase<T> = T extends Date
    ? T
    : T extends Array<infer U>
      ? Array<ToCamelCase<U>>
      : T extends object
        ? { [K in keyof T as CamelCase<string & K>]: ToCamelCase<T[K]> }
        : T;

export type OmitUndefinedAndNever<T> = {
    [K in keyof T as [T[K]] extends [never] ? never : [T[K]] extends [undefined] ? never : K]: T[K];
};

// Cleaned final type
export type CleanedCamelCase<T> = ToCamelCase<OmitUndefinedAndNever<T>>;
